import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  hasMany,
  options,
  references,
} from '@apexdesigner/schema-tools';

export const userTask = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Optional name for this task'),

    userInterface: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Name of the user interface component to render for this task, captured at creation',
      ),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Complete', name: 'Complete' },
      { value: 'Canceled', name: 'Canceled' },
    ])
      .nullable()
      .optional()
      .describe('Current state of this task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe(
        'In-progress working data for this task, merged into process instance data on completion',
      ),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this task was finished'),

    loopIndex: z
      .number()
      .nullable()
      .optional()
      .describe('Loop index for multi-instance activities'),

    resultApplied: z
      .boolean()
      .nullable()
      .optional()
      .hidden()
      .describe(
        "Whether this iteration's completion has been folded into the process instance (before-complete hook and output mappings)",
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    roleId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('select-role')
      .describe('Foreign key to Role'),

    userId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('select-user')
      .describe('Foreign key to User'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    token: belongsTo('Token'),

    role: references('Role'),

    user: references('User'),

    userTaskHistories: hasMany('UserTaskHistory'),

    tenant: references('Tenant'),
  })
  .describe('A task that requires a user to take action')
  .as('UserTask');

export { userTask as userTaskSchema };
